import { T } from '../domaine/libelles'
import { surEvenement } from '../noyau/bus'
import { basculerTheme, themeCourant } from './theme'
import { el, heure, requis, vibrer, vider } from './dom'

/*
  Barre d'état.

  Hors réseau n'est pas une panne, c'est l'état normal d'une plage : c'est un
  simple témoin, jamais une alerte, jamais un dialogue.
*/

function rendre(): void {
  const noeud = requis('barre-etat')
  const enLigne = navigator.onLine !== false
  const nuit = themeCourant() === 'rouge'

  vider(noeud)

  /*
    Raccourci du mode nuit rouge.

    C'est là que la DA affiche déjà « NUIT ROUGE · 21:07 » : l'endroit dit
    l'état, autant qu'il permette d'en changer. Le contrôle principal, plus
    explicite, reste dans l'écran Lampe.

    L'apparence ne bouge pas d'un pixel, mais la zone tactile fait bien 56 px
    grâce au rembourrage compensé par des marges négatives (cf. app.css).
  */
  const bascule = el('button', {
    type: 'button',
    class: 'barre-etat__heure',
    text: nuit ? `${T.nuitRouge} · ${heure()}` : heure(),
    'aria-label': nuit ? T.passerEnNormal : T.passerEnNuit,
    'aria-pressed': nuit ? 'true' : 'false',
  })
  bascule.addEventListener('click', () => {
    vibrer(15)
    void basculerTheme()
  })

  noeud.append(
    el('div', { class: 'barre-etat__reseau' }, [
      el('span', { class: enLigne ? 'pastille pastille--douce' : 'pastille' }),
      el('span', {
        class: enLigne ? 'barre-etat__texte barre-etat__texte--doux' : 'barre-etat__texte',
        text: enLigne ? T.enReseau : T.horsReseau,
      }),
    ]),
    bascule,
  )
}

export function demarrerBarreEtat(): void {
  rendre()
  surEvenement('reseau-change', rendre)
  surEvenement('theme-change', rendre)
  window.addEventListener('online', rendre)
  window.addEventListener('offline', rendre)
  // L'heure affichée est à la minute : un rafraîchissement toutes les 20 s suffit.
  setInterval(rendre, 20_000)
}
